

export const defaultForAdminUserSearchRequest = () => {
    return AdminUserSearchRequest.fromJS({
        searchText:'',
        includeDisabled: false
    });
}

export class AdminUserSearchRequest implements IAdminUserSearchRequest {
  searchText?: string | undefined;
  includeDisabled?: boolean;
  includeSystemAdmin?: boolean;
  includeContentAdmin?: boolean;
  dateAddedFrom?: Date | undefined;
  dateAddedTo?: Date | undefined;

  constructor(data?: IAdminUserSearchRequest) {
    if (data) {
      for (const property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.searchText = _data['searchText'];
      this.includeDisabled = _data['includeDisabled'];
      this.includeSystemAdmin = _data['includeSystemAdmin'];
      this.includeContentAdmin = _data['includeContentAdmin'];
      this.dateAddedFrom = _data['dateAddedFrom'] ? new Date(_data['dateAddedFrom'].toString()) : <any>undefined;
      this.dateAddedTo = _data['dateAddedTo'] ? new Date(_data['dateAddedTo'].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): AdminUserSearchRequest {
    data = typeof data === 'object' ? data : {};
    const result = new AdminUserSearchRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['searchText'] = this.searchText;
    data['includeDisabled'] = this.includeDisabled;
    data['includeSystemAdmin'] = this.includeSystemAdmin;
    data['includeContentAdmin'] = this.includeContentAdmin;
    data['dateAddedFrom'] = this.dateAddedFrom ? this.dateAddedFrom.toISOString() : <any>undefined;
    data['dateAddedTo'] = this.dateAddedTo ? this.dateAddedTo.toISOString() : <any>undefined;
    return data;
  }
}

export interface IAdminUserSearchRequest {
  searchText?: string | undefined;
  includeDisabled?: boolean;
  includeSystemAdmin?: boolean;
  includeContentAdmin?: boolean;
  dateAddedFrom?: Date | undefined;
  dateAddedTo?: Date | undefined;
}